import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { BackButton } from '@/components/BackButton';
import { Preloader } from '@/components/Preloader';
import { useGetBrandDetailBySlug } from '@/query/queries/brand/useGetBrandDetailBySlug';
import { canGoBack } from '@/helpers/utils';
import { APP_LINKS } from '@/helpers/links';
import { BrandDetail } from './components/BrandDetail';
import s from './index.module.scss';

const BrandDetailPage = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const { data: brand, isLoading, isFetching } = useGetBrandDetailBySlug(slug);
  const { t } = useTranslation('brands');

  const onBack = () => {
    canGoBack() ? navigate(-1) : navigate(APP_LINKS.startups);
  };

  const loading = isLoading || isFetching;

  return (
    <div className={s.wrapper}>
      <div className="container-inner">
        <div className={s.back}>
          <BackButton onClick={onBack} />
        </div>
        {loading ? (
          <Preloader className={s.preloader} />
        ) : brand ? (
          <BrandDetail brand={brand} />
        ) : (
          <div className={s.empty}>{t('brand_detail.could_not_load')}</div>
        )}
      </div>
    </div>
  );
};

export default BrandDetailPage;
